/**
 * 报名成员职能（与前台 Step2 一致，管理端中文展示）
 */
export const MEMBER_FUNCTION_OPTIONS = [
  { value: 'Gymnast', label: '体操运动员' },
  { value: 'Heads of delegation', label: '代表团团长' },
  { value: 'NF President and NF President guest', label: '联合会主席及嘉宾' },
  { value: 'NF President and NF President guest VIP', label: '联合会主席及嘉宾VIP' },
  { value: 'Medical doctor', label: '医生' },
  { value: 'Mental Health Professional', label: '心理健康专业人员' },
  { value: 'Guest', label: '嘉宾' },
  { value: 'Guest VIP', label: '嘉宾VIP' },
  { value: 'Team manager (TRA)', label: '蹦床队经理 (TRA)' },
  { value: 'Coach (TRA)', label: '蹦床教练 (TRA)' },
  { value: 'Paramedical staff (TRA)', label: '蹦床医务保障 (TRA)' },
  { value: 'TRA Senior Judge', label: '蹦床高级裁判 (TRA)' },
  { value: 'Team manager (TUM)', label: '技巧队经理 (TUM)' },
  { value: 'Coach (TUM)', label: '技巧教练 (TUM)' },
  { value: 'Paramedical staff (TUM)', label: '技巧医务保障 (TUM)' },
  { value: 'TUM Senior Judge', label: '技巧高级裁判 (TUM)' },
  { value: 'Team manager (DMT)', label: '双杠队经理 (DMT)' },
  { value: 'Coach (DMT)', label: '双杠教练 (DMT)' },
  { value: 'Paramedical staff (DMT)', label: '双杠医务保障 (DMT)' },
  { value: 'DMT Senior Judge', label: '双杠高级裁判 (DMT)' },
  { value: 'Coach', label: '教练' },
  { value: 'Judge', label: '裁判' },
  { value: 'Team Manager', label: '队伍经理' },
];
